import {
  RECEIVE_MAPPINGS,
  RECEIVE_GEOMETRIES,
  IMPORTED_MAPPING_AT,
  RESET_MAPPINGS_IMPORTED_AT,
  MAPPINGS_IMPORT_ERRORS,
} from './actions';

const initialState = {
  mappingsImportedAt: 0,
  importErrors: [],
  mappingsBySite: {
    /*
    siteId: {
      ids: [<mappingId1>, <mappingId2>],
      modelAndDesignationToMappingId: {},
      mappings: {
        [<mappingId1>]: <mapping1>,
        [<mappingId2>]: <mapping2>,
      },
    },
    */
  },
  geometriesBySiteAndModel: {
    /*
    siteId: {
      modelId1: [
        {
          ...geoData,
        },
        {
          ...geo2Data
        },
      ],
    },
    */
  },
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_MAPPINGS: {
      const { mappings, siteId } = action;
      const ids = [];
      const modelAndDesignationToMappingId = {};
      const mappingsById = mappings.reduce((acc, mapping) => {
        ids.push(mapping.id);
        for (const d of mapping.itemDesignations) {
          modelAndDesignationToMappingId[`${mapping.model_id}@${d}`] = mapping.id;
        }
        return { ...acc, [mapping.id]: mapping };
      }, {});

      return {
        ...state,
        mappingsBySite: {
          ...state.mappingsBySite,
          [siteId]: {
            ids,
            modelAndDesignationToMappingId,
            mappings: mappingsById,
          },
        },
      };
    }

    case RECEIVE_GEOMETRIES: {
      const { siteId, modelId, geometries } = action;

      return {
        ...state,
        geometriesBySiteAndModel: {
          ...state.geometriesBySiteAndModel,
          [siteId]: {
            ...state.geometriesBySiteAndModel[siteId],
            [modelId]: geometries,
          },
        },
      };
    }

    case IMPORTED_MAPPING_AT: {
      const { importedAt } = action;
      return { ...state, mappingsImportedAt: importedAt };
    }

    case RESET_MAPPINGS_IMPORTED_AT: {
      return { ...state, mappingsImportedAt: 0 };
    }
    case MAPPINGS_IMPORT_ERRORS: {
      return { ...state, importErrors: action.errors };
    }

    default: {
      return state;
    }
  }
}
